/**
 * HIPAA dashboard — RDS connection-health API client.
 *
 * New, separate file from rlsAudit.js: this polls RDS's own /ready
 * signal (test-integration plan Phase 0), a different concern from
 * the RLS/PHI-deid audits that file already covers. GET, no body —
 * this is a read-only health poll, never a mutation.
 */
import { getBackendURL } from "../components/env";
import { supabasePublic } from "../components/supabaseClient";

export async function fetchRdsHealth() {
  const { data: { session } = {} } = await supabasePublic().auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error("No active session — sign in again");

  const res = await fetch(`${getBackendURL()}/api/admin/rds-health/`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.error) {
    throw new Error(json.error || `HTTP ${res.status}`);
  }
  return json;
}
